import { Color } from '@/modules/core/app/enums/Color';
import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class EstateTaskDocumentStatus extends Enum {
  static SENT_FOR_REVIEW = {
    key: 'sent_for_review',
    get value() {
      return Lang.t('estatetask.sent-for-review');
    },
    color: Color.GOLD_YELLOW
  };

  static CHANGES_REQUESTED = {
    key: 'changes_requested',
    get value() {
      return Lang.t('estatetask.changes-requested');
    },
    color: Color.BURNT_SIENNA
  };

  static APPROVED = {
    key: 'approved',
    get value() {
      return Lang.t('estatetask.approved');
    },
    color: Color.FRESH_GREEN
  };
}
